import * as React from 'react';
import { RedirectProps } from 'react-router';
import { Redirect } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';

export const PrivateRedirect = (props: RedirectProps) => {
  const { to, ...redirectProps } = props;
  return (
    <PrivateRoute {...redirectProps} render={() => <Redirect to={to} />} />
  );
};
